export default "__VITE_ASSET__Cb4acWR6__"